import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Jordan (1-42)
import jordan1 from '../images/jordan1.jpeg';
import jordan2 from '../images/jordan2.jpeg';
import jordan3 from '../images/jordan3.jpeg';
import jordan4 from '../images/jordan4.jpeg';
import jordan5 from '../images/jordan5.jpeg';
import jordan6 from '../images/jordan6.jpeg';
import jordan7 from '../images/jordan7.jpeg';
import jordan8 from '../images/jordan8.jpeg';
import jordan9 from '../images/jordan9.jpeg';
import jordan10 from '../images/jordan10.jpeg';
import jordan11 from '../images/jordan11.jpeg';
import jordan12 from '../images/jordan12.jpeg';
import jordan13 from '../images/jordan13.jpeg';
import jordan14 from '../images/jordan14.jpeg';
import jordan15 from '../images/jordan15.jpeg';
import jordan16 from '../images/jordan16.jpeg';
import jordan17 from '../images/jordan17.jpeg';
import jordan18 from '../images/jordan18.jpeg';
import jordan19 from '../images/jordan19.jpeg';
import jordan20 from '../images/jordan20.jpeg';
import jordan21 from '../images/jordan21.jpeg';
import jordan22 from '../images/jordan22.jpeg';
import jordan23 from '../images/jordan23.jpeg';
import jordan24 from '../images/jordan24.jpeg';
import jordan25 from '../images/jordan25.jpeg';
import jordan26 from '../images/jordan26.jpeg';
import jordan27 from '../images/jordan27.jpeg';
import jordan28 from '../images/jordan28.jpeg';
import jordan29 from '../images/jordan29.jpeg';
import jordan30 from '../images/jordan30.jpeg';
import jordan31 from '../images/jordan31.jpeg';
import jordan32 from '../images/jordan32.jpeg';
import jordan33 from '../images/jordan33.jpeg';
import jordan34 from '../images/jordan34.jpeg';
import jordan35 from '../images/jordan35.jpeg';
import jordan36 from '../images/jordan36.jpeg';
import jordan37 from '../images/jordan37.jpeg';
import jordan38 from '../images/jordan38.jpeg';
import jordan39 from '../images/jordan39.jpeg';
import jordan40 from '../images/jordan40.jpeg';
import jordan41 from '../images/jordan41.jpeg';
import jordan42 from '../images/jordan42.jpeg';

function Jordan() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    jordan1, jordan2, jordan3, jordan4, jordan5, jordan6, jordan7, jordan8, jordan9, jordan10,
    jordan11, jordan12, jordan13, jordan14, jordan15, jordan16, jordan17, jordan18, jordan19, jordan20,
    jordan21, jordan22, jordan23, jordan24, jordan25, jordan26, jordan27, jordan28, jordan29, jordan30,
    jordan31, jordan32, jordan33, jordan34, jordan35, jordan36, jordan37, jordan38, jordan39, jordan40,
    jordan41, jordan42
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇯🇴 Jordan 2019 🇯🇴</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Jordan ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Jordan;